<footer>
  <div
    class="w-[95%] md:w-[90%] max-w-[1600px] rounded-t-[60px] mx-auto px-6 py-10 lg:px-8 bg-white border-t border-slate-200 shadow-2xl">


    <div class="w-full h-auto border-b border-slate-200">

      <div class="w-full h-auto inline-flex justify-between items-start flex flex-wrap gap-2">
        <img [src]="logotypeUrl()" alt="footer-logo"
             class="w-[65%] sm:w-[45%] lg:w-[300px] lg:max-w-[80%] mb-4 object-cover">
        <img src="assets/general/iso/iso-27001_urs-urs.webp" alt="ISO 9001"
             class="h-22 lg:h-28 md:px-10 w-auto object-cover">
      </div>


      <div class="w-full grid grid-cols-1 md:grid-cols-3 max-lg:gap-y-8 p-5">

        <div class="col-span-1">
          <h3 i18n="@@utils.shortcut" class="text-primary-500 font-bold text-sm uppercase tracking-wider mb-4">
            Skrót
          </h3>
          <ul class="space-y-3">
            @for (section of sections(); track $index) {
              <li>
                <a [navigator]="section.id"
                   class="text-secondary-800 text-sm hover:text-slate-900 transition-colors cursor-pointer">
                  {{ section.label }}
                </a>
              </li>
            }
          </ul>
        </div>

        <div class="col-span-1">
          <h3 i18n="@@utils.contact" class="text-primary-500 font-bold text-sm uppercase tracking-wider mb-4">
            Kontakt
          </h3>

          @if (contact()) {
            <ul class="space-y-3">
              @for (phone of contact()?.phone; track $index) {
                <li>
                  <a href="tel:{{ phone }}" class="text-slate-600 text-sm hover:text-slate-900 transition-colors">
                    {{ phone }}
                  </a>
                </li>
              }
              @for (email of contact()?.email; track $index) {
                <li>
                  <a
                    (click)="trackEmailClick(email)"
                    href="mailto:{{ email }}"
                    class="text-slate-600 text-sm hover:text-slate-900 transition-colors">
                    {{ email }}
                  </a>
                </li>
              }
            </ul>
          }
        </div>

        <div class="col-span-1">
          <h3 i18n="@@utils.follow-us" class="text-primary-500 font-bold text-sm uppercase tracking-wider mb-4">
            Śledź nas
          </h3>
          <div class="flex gap-4">
            <a
              (click)="trackSocialMediaClick(linkedinSocialMediaType)"
              [href]="socialMediaUrls.linkedinPw"
              class="sm-icon text-slate-600 hover:text-blue-800">
              <ng-icon name="tablerBrandLinkedin"></ng-icon>
            </a>
            <a
              (click)="trackSocialMediaClick(facebookSocialMediaType)"
              [href]="socialMediaUrls.facebook"
              class="sm-icon text-slate-600 hover:text-blue-700">
              <ng-icon name="tablerBrandFacebook"></ng-icon>
            </a>
          </div>
        </div>
      </div>


      <div class="inline-block w-full h-auto text-center my-5">
        <span class="text-sm text-secondary-700">Proudly developed by
          <a [href]="socialMediaUrls.linkedinSh"
             class="text-primary-500 font-bold">
            ProcessWay Software House Team
          </a>
        </span>
      </div>
    </div>

    <div class="pt-8 flex flex-col md:flex-row justify-between items-center gap-4">

      <p i18n="@@utils.all-rights-reserved" class="text-slate-500 text-sm order-2 md:order-1">
        © {{ currentYear }} {{ label() }}. Wszelkie prawa zastrzeżone.
      </p>

      <div class="flex flex-wrap justify-center gap-6 order-1 md:order-2">
        <a i18n="@@link.privacy-policy" [href]="privacyPolicyUrl"
           class="text-slate-500 text-sm hover:text-slate-900 transition-colors">
          Polityka prywatności
        </a>
      </div>
    </div>
  </div>
</footer>
